import React, { useContext, useEffect, useState } from "react";
import { useMatch, useNavigate, useResolvedPath } from "react-router-dom";
import { COLOR_TEXT } from "../../../constants/colors";
import { IconCheveron } from "../../../icons/Icon";
import { StoreContext } from "../../../store/StoreContext";
import NavItemTemplate from "./NavItemTemplate";
import SubNavItem from "./SubNavItem";
import { SMU_SELECTED_MENU } from "../../../constants";

const defaultColor = "#32373E";

const NavItem = ({ route, addCurrentRoute }) => {
  const resolved = useResolvedPath(route.path);
  const navigate = useNavigate();

  const { sidebarExpand } = useContext(StoreContext);

  const [expand, setExpand] = useState(false);

  const match = useMatch({ path: resolved.pathname, end: false});
  const active = Boolean(match);
  const color = active ? COLOR_TEXT : defaultColor;
  const isChildren = route?.children?.length > 0;
  const showDropdown = route?.showDropdown || isChildren;

  useEffect(() => {
    if (!sidebarExpand) {
      setExpand(false);
      return;
    }

    if (active && isChildren) setExpand(true);
  }, [sidebarExpand]);

  const handleClick = () => {
    // Clear SMU_SELECTED_MENU when navigating to any view (except Faldones which is just a dropdown parent)
    if (route.id !== 3) {
      localStorage.removeItem(SMU_SELECTED_MENU);
      // Notify listeners (e.g., promotions view) that the selected menu changed/was cleared
      window.dispatchEvent(new Event("smu-selected-menu-changed"));
    }

    if (showDropdown) {
      // Toggle dropdown when clicking main area (for items like "Faldones")
      setExpand((val) => !val);
      // Navigation will happen if noRedirect is false
      if (!route.noRedirect) {
        navigate(route.path);
        addCurrentRoute(route);
      }
    } else {
      if (!route.noRedirect) {
        navigate(route.path);
        addCurrentRoute(route);
      }
    }
  };

  const handleExpandClick = () => {
    // Only toggle expand/collapse, no navigation
    setExpand((val) => !val);
  };

  return (
    <NavItemTemplate
      title={route.title}
      handleClick={handleClick}
      handleExpandClick={showDropdown ? handleExpandClick : null}
      active={active}
      icon={route?.Icon && <route.Icon color={color} />}
      buttonExpand={
        showDropdown && (
          <IconCheveron color="#33383F" />
        )
      }
    >
      {isChildren && (
        <div className={`menu-item-child ${expand ? "expand" : ""}`}>
          {route.children.map((item) => (
            <SubNavItem
              key={item.id}
              item={item}
              addCurrentRoute={addCurrentRoute}
            />
          ))}
        </div>
      )}
    </NavItemTemplate>
  );
};

export default NavItem;
